import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { combineLatest, map, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '../../strategy.actions';
import * as fromAppRoot from '@app/app.reducers';
import * as fromStrategy from '@strategy/reducers';

@Component({
  selector: 'app-setup-strategy',
  templateUrl: './setup-strategy.component.html',
  styleUrls: ['./setup-strategy.component.scss'],
  standalone: false
})
export class SetupStrategyComponent implements OnDestroy, OnInit {
  @Input() step: number;
  @Input() is3aPillar: boolean;
  @Input() tabSelected: number;
  appLocation$: Observable<string>;
  riskToStrategyLoader$: Observable<boolean>;
  isStrategyInitialised: boolean;

  protected readonly onDestroy$ = new Subject<void>();

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(StrategyActions.getLatestStrategyDataEve2());

    this.riskToStrategyLoader$ = this.store.select(fromStrategy.selectRiskToStrategyLoaderEve2);

    const currentAccount$ = this.store.select(fromAppRoot.selectCurrentInvestAccount);
    const isEditModeEve2$ = this.store.select(fromStrategy.selectIsEditModeEve2);

    combineLatest([currentAccount$, isEditModeEve2$])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(([currentAccount, isEditMode]) => {
        const tabIndex = currentAccount?.step_status === 5 ? (isEditMode ? 3 : 5) : currentAccount?.ql_onboarding_step;
        this.store.dispatch(StrategyActions.setTabIndex({ tabIndex }));
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
